import { PeriodFilterEnum } from '@/ui';
import { ReportDateRange } from './report-date-filter';

/**
 * Which bucket sizes a report may be grouped by, and how that choice
 * round-trips through the `?p=` query string.
 *
 * A short range has too few weeks or months to plot, and a long one has too
 * many days, so the allowed periods follow the range rather than being fixed.
 */

export function getAllowedPeriods(range: ReportDateRange): PeriodFilterEnum[] {
    const daysCount = Math.ceil(
        (range.to.getTime() - range.from.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (daysCount <= 7) {
        return [PeriodFilterEnum.Daily];
    } else if (daysCount <= 28) {
        return [PeriodFilterEnum.Daily, PeriodFilterEnum.Weekly];
    } else if (daysCount <= 93) {
        return [
            PeriodFilterEnum.Daily,
            PeriodFilterEnum.Weekly,
            PeriodFilterEnum.Monthly
        ];
    } else {
        return [PeriodFilterEnum.Weekly, PeriodFilterEnum.Monthly];
    }
}

export function getPeriodFromQueryString(
    value: string | null | undefined
): PeriodFilterEnum {
    switch (value) {
        case 'd':
            return PeriodFilterEnum.Daily;
        case 'w':
            return PeriodFilterEnum.Weekly;
        case 'm':
            return PeriodFilterEnum.Monthly;
        default:
            return PeriodFilterEnum.Daily;
    }
}

export function getPeriodQueryString(value: PeriodFilterEnum): string {
    switch (value) {
        case PeriodFilterEnum.Daily:
            return 'd';
        case PeriodFilterEnum.Weekly:
            return 'w';
        case PeriodFilterEnum.Monthly:
            return 'm';
        default:
            return '';
    }
}
